import { Card, Stack, styled, Text } from 'shell/components';

const ChatPromptSuggestions = ({ suggestions, disabled, onSelect }) => {
    if (!suggestions.length) return null;

    return (
        <SuggestionsStack spacing={2.5}>
            {suggestions.map((suggestion) => (
                <SuggestionCard
                    key={suggestion.text}
                    disabled={disabled}
                    role={'button'}
                    tabIndex={disabled ? -1 : 0}
                    onClick={() => !disabled && onSelect(suggestion.text)}
                    onKeyDown={(event) => {
                        if (disabled) return;
                        if (event.key === 'Enter' || event.key === ' ') {
                            event.preventDefault();
                            onSelect(suggestion.text);
                        }
                    }}
                >
                    <Text variant={'p3'}>{suggestion.text}</Text>
                </SuggestionCard>
            ))}
        </SuggestionsStack>
    );
};

const SuggestionsStack = styled(Stack)(() => {
    return {
        width: '330px',
        maxWidth: '100%',
        alignSelf: 'flex-end',
    };
});

const SuggestionCard = styled(Card)(({ theme }) => {
    return {
        boxShadow: 'none',
        background: 'rgba(255, 255, 255, 0.75)',
        backdropFilter: 'blur(4px)',

        '& > p': {
            fontSize: `${theme.typography.p2.fontSize.large}rem`,
        },
    };
});

export default ChatPromptSuggestions;
